import { localStorageKeys } from "@/lib/utils";
import { GlobalSupplierStorageObject } from "@/app/Suppliers/Utils/globalSupplierTypes";

/**
 * Variables for the `globalSupplierSelectionList` query. Shared so the
 * app-layout loader's warm-up and every reader (useGlobalSupplier, the entry
 * guards) hit the exact same React Query cache key.
 */
export const SUPPLIER_LIST_VARIABLES = { page: 1, first: 200 };

/** Optional URL param → app value. `undefined` (absent) → null = all suppliers. */
export function supplierParamToId(
  supplierId: string | undefined,
): string | null {
  return supplierId ?? null;
}

/** App value → optional URL param. `null` (all) → `undefined` (omit the segment). */
export function supplierIdToParam(
  supplierId: string | null,
): string | undefined {
  return supplierId ?? undefined;
}

/**
 * Supplier a Settings screen is editing. The global path param wins; when it's
 * absent ("all suppliers") the settings-scoped `?supplier=` search param picks
 * one to edit without touching the global selection.
 */
export function resolveSettingsSupplierId(
  params: { supplierId?: string },
  search: { supplier?: string },
): string | null {
  return supplierParamToId(params.supplierId) ?? search.supplier ?? null;
}

/**
 * Legacy supplier selection from the old localStorage-based store. Read once
 * during URL migration to carry the user's last choice into the new URL.
 */
export function readLegacyGlobalSupplierId(): string | null {
  const json = localStorage.getItem(localStorageKeys.GLOBAL_SUPPLIER);
  if (json === null) return null;

  try {
    const obj = JSON.parse(json) as GlobalSupplierStorageObject;
    return obj.type === "single" ? obj.id : null;
  } catch {
    return null;
  }
}

/** Drop the obsolete localStorage supplier store. */
export function clearLegacyGlobalSupplier() {
  localStorage.removeItem(localStorageKeys.GLOBAL_SUPPLIER);
}
